export default __webpack_public_path__ + "static/media/calculator-icon.1159cfe1.svg";